import CryptoJS from 'crypto-js';

function getKey() {
  const secretKey = process.env.REACT_APP_ENCRYPTION_KEY;
  if (!secretKey || secretKey.length < 32) {
    throw new Error('Invalid or missing REACT_APP_ENCRYPTION_KEY. Must be at least 32 characters long.');
  }
  return CryptoJS.enc.Utf8.parse(secretKey.slice(0, 32));
}

export function encryptPayload(data) {
  try {
    const key = getKey();
    const iv = CryptoJS.lib.WordArray.random(16);
    
    const textToEncrypt = typeof data === 'string' ? data : JSON.stringify(data);
    
    const encrypted = CryptoJS.AES.encrypt(textToEncrypt, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    
    const ivHex = iv.toString(CryptoJS.enc.Hex);
    const encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    
    return ivHex + ':' + encryptedHex;
  } catch (err) {
    console.error('Encryption failed:', err);
    throw new Error('Encryption failed');
  }
}

export function decryptString(encryptedPayload) {
  try {
    const key = getKey();
    const textParts = encryptedPayload.split(':');
    if (textParts.length !== 2) {
      throw new Error('Invalid encrypted payload format');
    }
    
    const iv = CryptoJS.enc.Hex.parse(textParts[0]);
    const ciphertext = CryptoJS.enc.Hex.parse(textParts[1]);
    const cipherParams = CryptoJS.lib.CipherParams.create({ ciphertext: ciphertext });
    
    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error('Decryption failed:', err);
    throw new Error('Decryption failed');
  }
}

export function decryptPayload(encryptedPayload) {
  try {
    const decryptedText = decryptString(encryptedPayload);
    try {
      return JSON.parse(decryptedText);
    } catch (e) {
      return decryptedText;
    }
  } catch (err) {
    throw err;
  }
}
